"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var component_svg_1 = __importDefault(require("@doordash/component-svg"));
var React = __importStar(require("react"));
/* tslint:disable:max-line-length */
var DinersClub = function (_a) {
    var size = _a.size;
    return (React.createElement(component_svg_1["default"], { viewBox: "0 0 48 48", height: size, width: size },
        React.createElement("g", { id: "surface1" },
            React.createElement("path", { fill: "#CFD8DC", d: "M 45 35 C 45 37.199219 43.199219 39 41 39 L 7 39 C 4.800781 39 3 37.199219 3 35 L 3 13 C 3 10.800781 4.800781 9 7 9 L 41 9 C 43.199219 9 45 10.800781 45 13 Z " }),
            React.createElement("path", { fill: "#1565C0", d: "M 29 16 L 19 16 C 14.601563 16 11 19.601563 11 24 C 11 28.398438 14.601563 32 19 32 L 29 32 C 33.398438 32 37 28.398438 37 24 C 37 19.601563 33.398438 16 29 16 Z " }),
            React.createElement("path", { fill: "#FFFFFF", d: "M 19 18 C 15.699219 18 13 20.699219 13 24 C 13 27.300781 15.699219 30 19 30 C 22.300781 30 25 27.300781 25 24 C 25 20.699219 22.300781 18 19 18 Z M 15 24 C 15 22.101563 16.300781 20.601563 18 20.101563 L 18 27.800781 C 16.300781 27.398438 15 25.898438 15 24 Z M 20 27.898438 L 20 20.199219 C 21.699219 20.601563 23 22.199219 23 24.101563 C 23 25.898438 21.699219 27.398438 20 27.898438 Z " }))));
};
/* tslint:enable:max-line-length */
exports["default"] = DinersClub;
